"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderImage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const icon_button_1 = require("@alfalab/core-components/icon-button");
const hooks_1 = require("@alfalab/hooks");
const ArrowBackHeavyMIcon_1 = require("@alfalab/icons-glyph/ArrowBackHeavyMIcon");
const ArrowBackMIcon_1 = require("@alfalab/icons-glyph/ArrowBackMIcon");
const CrossHeavyMIcon_1 = require("@alfalab/icons-glyph/CrossHeavyMIcon");
const CrossMIcon_1 = require("@alfalab/icons-glyph/CrossMIcon");
const service_button_1 = require("../../service-button");
const component_context_1 = require("../context/component.context");
const typography_title_platform_1 = require("../typography/typography-title-platform");
const index_module_css_1 = __importDefault(require("./index.module.css"));
/**
 * <SidePanel.HeaderImage>
 *
 * Блок-заголовок для SidePanel. Представляет собой картинку с размерами 2:1 и sticky-заголовок под ней.
 */
const HeaderImage = ({ bgImageUrl, hasCloser = true, title, onBackClick, }) => {
    const { platform, isMobile, isResponsive, isDesktop } = (0, react_1.useContext)(component_context_1.AdditionalContext);
    const { onClose, componentRef } = (0, react_1.useContext)(component_context_1.SidePanelContext);
    /** стейт скрытия картинки */
    const [imageFaded, setImageFaded] = (0, react_1.useState)(false);
    /** стейт пересечения хедера с верхним блоком - для состояния с кнопкой Назад */
    const [headerIntersected, setHeaderIntersected] = (0, react_1.useState)(false);
    const visibleStickyWrapper = hasCloser || onBackClick;
    const [isResponsiveDesktopView] = (0, hooks_1.useMedia)([[true, '(min-width: 1024px)']], false);
    const desktopView = isDesktop || (isResponsive && isResponsiveDesktopView);
    const style = (0, react_1.useMemo)(() => ({
        backgroundImage: bgImageUrl ? `url(${bgImageUrl})` : 'none',
    }), [bgImageUrl]);
    const platformStyles = {
        [index_module_css_1.default.mobile]: isMobile,
        [index_module_css_1.default.responsive]: isResponsive,
    };
    const handleClose = (event) => {
        onClose(event, 'closerClick');
    };
    const toggleImageFaded = (entries) => {
        entries.forEach((entry) => {
            if (entry.target.className.includes(index_module_css_1.default.header)) {
                setImageFaded(entry.isIntersecting);
            }
        });
    };
    const toggleHeaderFaded = (entries) => {
        entries.forEach((entry) => {
            if (entry.target.className.includes(index_module_css_1.default.header)) {
                setHeaderIntersected(entry.isIntersecting);
            }
        });
    };
    const startHeaderImageObserver = (0, react_1.useCallback)(() => {
        try {
            /** Размер области, при которой необходимо начинать перестроение блока хедера с кнопкой Назад */
            const headerMargin = desktopView ? 60 : 40;
            /** Отслеживание необходимости скрытия картинки */
            const imageObserver = new IntersectionObserver(toggleImageFaded, {
                root: componentRef === null || componentRef === void 0 ? void 0 : componentRef.current,
                rootMargin: `0px 0px ${8 - window.innerHeight}px`,
                threshold: 0,
            });
            /** Отслеживание необходимости перестраивания хедера с кнопкой Назад  */
            const headerObserver = onBackClick
                ? new IntersectionObserver(toggleHeaderFaded, {
                    root: componentRef === null || componentRef === void 0 ? void 0 : componentRef.current,
                    rootMargin: `0px 0px ${headerMargin - window.innerHeight}px`,
                    threshold: 0,
                })
                : null;
            const element = document.querySelector(`.${index_module_css_1.default.header}`);
            return {
                imageObserver,
                headerObserver,
                element,
            };
        }
        catch (_a) {
            return {};
        }
    }, [componentRef, desktopView, onBackClick]);
    (0, react_1.useEffect)(() => {
        const { imageObserver, headerObserver, element } = startHeaderImageObserver();
        if (onBackClick) {
            headerObserver === null || headerObserver === void 0 ? void 0 : headerObserver.observe(element);
        }
        if (!isMobile) {
            imageObserver === null || imageObserver === void 0 ? void 0 : imageObserver.observe(element);
        }
        return () => {
            imageObserver === null || imageObserver === void 0 ? void 0 : imageObserver.disconnect();
            headerObserver === null || headerObserver === void 0 ? void 0 : headerObserver.disconnect();
        };
    }, [startHeaderImageObserver, isMobile, onBackClick]);
    return ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [visibleStickyWrapper && ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)(index_module_css_1.default.stickyHeader, platformStyles), children: [onBackClick && ((0, jsx_runtime_1.jsx)(service_button_1.ServiceButton, { dataTestId: 'side-panel-header-back', className: (0, classnames_1.default)(index_module_css_1.default.backButtonWrapper, platformStyles), onClick: onBackClick, leftAddon: desktopView ? (0, jsx_runtime_1.jsx)(ArrowBackHeavyMIcon_1.ArrowBackHeavyMIcon, {}) : (0, jsx_runtime_1.jsx)(ArrowBackMIcon_1.ArrowBackMIcon, {}), leftAddonBackground: true, leftAddonClassName: (0, classnames_1.default)(index_module_css_1.default.backButtonAddon, {
                            [index_module_css_1.default.desktop]: desktopView,
                        }), children: !desktopView && 'Назад' })), hasCloser && ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(index_module_css_1.default.closeButtonWrapper, platformStyles), children: (0, jsx_runtime_1.jsx)(icon_button_1.IconButton, { className: (0, classnames_1.default)(index_module_css_1.default.iconButton, {
                                [index_module_css_1.default.desktopView]: desktopView,
                            }), alignIcon: 'center', title: '\u0417\u0430\u043A\u0440\u044B\u0442\u044C', onClick: handleClose, icon: desktopView ? CrossHeavyMIcon_1.CrossHeavyMIcon : CrossMIcon_1.CrossMIcon, dataTestId: 'sidepanel-header-image-close', size: desktopView ? 's' : 'xs' }) }))] })), (0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(index_module_css_1.default.backgroundImageContainer, platformStyles), children: (0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(index_module_css_1.default.image, { [index_module_css_1.default.faded]: imageFaded }), style: style, role: 'img' }) }), (0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(index_module_css_1.default.header, {
                    [index_module_css_1.default.animated]: headerIntersected,
                    [index_module_css_1.default.mobile]: !desktopView,
                    [index_module_css_1.default.transformed]: onBackClick,
                }), children: title && ((0, jsx_runtime_1.jsx)(typography_title_platform_1.TypographyTitlePlatform, { tag: 'div', view: 'medium', color: 'primary', className: (0, classnames_1.default)(index_module_css_1.default.title, { [index_module_css_1.default.animated]: headerIntersected }), dataTestId: 'title', platform: platform, children: title })) })] }));
};
exports.HeaderImage = HeaderImage;
